export default __webpack_public_path__ + "static/media/Mystic's Breastplate of the Aureate.8168cac6.jpg";